import { updateHolePlacement } from './HolePlacementHelper';
import { WINDOW_RESIZED } from '../Rutab/RutabConstants';
const DPI = 96;
export const mmToPixels = (mm) => (mm / 25.4) * DPI;
export const pixelsToMM = (pixels) => (pixels * 25.4) / DPI;
export const canvasPixelsToMM = (pixels) => {
    return pixelsToMM(pixels);
};
export const mmToCanvasPixels = (mm) => {
    return mmToPixels(mm);
};
export const sizes = {
    A1: { height: 841, width: 594 },
    A2: { height: 594, width: 420 },
    A3: { height: 420, width: 297 },
    A4: { height: 297, width: 210 },
    A5: { height: 210, width: 148 },
    Custom: { height: 210, width: 148 },
};
export const scaleCanvasToFit = (mmWidth, mmHeight) => {
    const mainContent = document.querySelector('.main-content-canvas');
    if (!mainContent)
        return {
            displayWidth: mmToPixels(mmWidth),
            displayHeight: mmToPixels(mmHeight),
        };
    const maxWidth = mainContent.clientWidth - 100;
    const maxHeight = mainContent.clientHeight - 100;
    const aspectRatio = mmWidth / mmHeight;
    let displayHeight = maxHeight;
    let displayWidth = displayHeight * aspectRatio;
    if (displayWidth > maxWidth) {
        displayWidth = maxWidth;
        displayHeight = displayWidth / aspectRatio;
    }
    if (aspectRatio > 3 || aspectRatio < 0.33) {
        const widthRatio = maxWidth / (mmWidth * (96 / 25.4));
        const heightRatio = maxHeight / (mmHeight * (96 / 25.4));
        const fitRatio = Math.min(widthRatio, heightRatio);
        displayWidth = mmWidth * (96 / 25.4) * fitRatio;
        displayHeight = mmHeight * (96 / 25.4) * fitRatio;
    }
    return { displayWidth, displayHeight };
};
export const handleSizeChange = (canvasSize, fabricCanvas, selectedHoles = 'none', renderAll = true, moveObjects = true) => {
    const realWidthPx = mmToPixels(canvasSize.width);
    const realHeightPx = mmToPixels(canvasSize.height);
    const { displayWidth, displayHeight } = scaleCanvasToFit(canvasSize.width, canvasSize.height);
    const fitRatio = displayHeight / realHeightPx;
    fabricCanvas.setDimensions({
        width: displayWidth,
        height: displayHeight,
    });
    fabricCanvas.setZoom(fitRatio);
    if (fabricCanvas.clipPath) {
        fabricCanvas.clipPath.scaleToWidth(realWidthPx);
        fabricCanvas.clipPath.scaleToHeight(realHeightPx);
        fabricCanvas.clipPath.set({
            left: displayWidth / 2,
            top: displayHeight / 2,
        });
    }
    if (selectedHoles !== 'none') {
        updateHolePlacement(fabricCanvas, selectedHoles);
    }
    if (moveObjects) {
        moveObjectsInsideCanvas(fabricCanvas);
    }
    fabricCanvas.set({ canvasSize: canvasSize });
    if (renderAll) {
        fabricCanvas.renderAll();
    }
};
export const updateMeasurementPositions = (mmHeight, mmWidth, fabricRef) => {
    const canvasElement = fabricRef;
    const measurementLeft = document.getElementById('measurementLeft');
    const measurementBottom = document.getElementById('measurementBottom');
    const canvasRect = canvasElement.getBoundingClientRect();
    if (canvasElement && measurementLeft && measurementBottom) {
        measurementLeft.style.top = `${canvasRect.top + canvasRect.height / 2 - 27 / 2}px`;
        measurementLeft.style.left = `${canvasRect.left - 70}px`;
        measurementBottom.style.top = `${canvasRect.bottom + 10}px`;
        measurementBottom.style.left = `${canvasRect.left + canvasRect.width / 2 - 72.45 / 2}px`;
        measurementLeft.innerText = `${mmHeight} mm`;
        measurementBottom.innerText = `${mmWidth} mm`;
    }
};
export const moveObjectsInsideCanvas = (fabricCanvas) => {
    const canvasWidth = fabricCanvas.getWidth();
    const canvasHeight = fabricCanvas.getHeight();
    const zoom = fabricCanvas.getZoom();
    const centerX = canvasWidth / 2;
    const centerY = canvasHeight / 2;
    const objects = fabricCanvas.getObjects();
    objects.forEach((obj) => {
        obj.setCoords();
        const boundingRect = obj.getBoundingRect();
        const objWidth = boundingRect.width * zoom;
        const objHeight = boundingRect.height * zoom;
        const newLeft = (centerX - objWidth / 2) / zoom;
        const newTop = (centerY - objHeight / 2) / zoom;
        obj.set({
            left: newLeft,
            top: newTop,
        });
        obj.setCoords();
    });
    fabricCanvas.renderAll();
};
export const handleWindowResize = (canvas, fabricRef) => (dispatch) => {
    document.querySelectorAll('.measurement').forEach((element) => {
        element.classList.toggle('hidden', false);
    });
    if (canvas) {
        const canvasSize = canvas.get('canvasSize');
        handleSizeChange(canvasSize, canvas, 'none', true, false);
        updateMeasurementPositions(canvasSize.height, canvasSize.width, fabricRef);
        dispatch({
            type: WINDOW_RESIZED,
        });
    }
};
export const debounce = (func, delay) => {
    let timeoutId = null;
    return (...args) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func(...args);
            timeoutId = null;
        }, delay);
    };
};
